module.exports = __webpack_public_path__ + "img/department.6a27bcc7.svg";